import { useState } from 'react';
import Drawer from 'react-modern-drawer';
import TransactionServices from '../TransactionServices';

export default function ISRCMappingSelect(param: any) {

    let [searchISRCText, setsearchISRCText] = useState("");
    let [searchISRCList, setsearchISRCList] = useState<any>([]);
    let [searchISRCResults, setsearchISRCResults] = useState(0);
    let [searchISRCTextFlag, setsearchISRCTextFlag] = useState(false);

    const searchISRC = () => {
        TransactionServices.getItemCodeSoldTracks({ intStdRecCde: searchISRCText }).then((respond: any) => {
            console.log(respond?.track)
            searchISRCList = respond?.track
            setsearchISRCList(searchISRCList)

            searchISRCResults = respond?.track[0]?.totalRows ?? 0
            setsearchISRCResults(searchISRCResults)

            searchISRCTextFlag = true;
            setsearchISRCTextFlag(searchISRCTextFlag)
        })
    }

    const ISRCMappingSelectionClose = () => { param.ISRCMappingSelectionClose() }

    const selectedISRC = (selectISRC: any) => { param.ISRCMappingSelectionClose(selectISRC) }

    return (
        <>
            <Drawer open={param.ISRCMappingSelectionOpen} onClose={ISRCMappingSelectionClose} direction='right' className='react-drawer-left allowHscroll'>
                <div className="box  ws-6 pull-right">

                    <div className="box-header-main">
                        <h2  > ISRC Selection</h2>
                    </div>

                    <div className="box-content">

                        <div className="ws-6">
                            <div className="form-format">
                                <label className="control-label ">Search ISRC</label>
                                <div className="label-entries">
                                    <div className="ws-8">
                                        <input type="text" value={searchISRCText} onChange={(e: any) => setsearchISRCText(e.target.value)} placeholder="Search ISRC" />
                                    </div>

                                    <div className="ws-4">
                                        <button className=" icon-btn edit" onClick={searchISRC}> <i className="icon-search"></i> </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {searchISRCText.length > 0 && searchISRCTextFlag && searchISRCResults == 0 && <div className="alert alert-success">No ISRC Matched your search criteria</div>}
                        {searchISRCText.length == 0 && searchISRCTextFlag && <div className="alert alert-success">Please search an ISRC  </div>}

                        <div className="ws-12">

                            {searchISRCText.length > 0 && <h2> {searchISRCResults} record(s) found</h2>}

                            {searchISRCResults > 0 && <table className="newTable">
                                <thead>
                                    <tr>
                                        <th >ISRC</th>
                                        <th >Track Artist</th>
                                        <th >Track Title</th>
                                        <th >Operations</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        searchISRCList?.map((values: any) => {
                                            return (

                                                <tr>
                                                    <td  >{values?.intStdRecCode}</td>
                                                    <td  >{values?.isrcArtistName}</td>
                                                    <td  >{values?.trackTitle}</td>
                                                    <td><a className=" icon-btn primary" onClick={() => selectedISRC(values)}>
                                                        <i className="icon-th icon-white"></i>Select</a>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>}

                            <div className="clearfix">

                            </div>

                        </div>

                    </div>

                    <div className="box-footer pull-right">
                        <button className=" icon-btn delete btn-sm " onClick={ISRCMappingSelectionClose}>
                            <i className="icon-close"></i> Close
                        </button>
                    </div>

                </div>
            </Drawer>
        </>
    )
}